import Table, { ColumnsType } from 'antd/lib/table';
interface DataType {
  key: React.Key;
  id: number;
  deliveredDate: string;
  location: string;
  estimatedQuantity: number;
  deliveredQuantity: number;
  availableQuantity: number;
  unavailableQuantity: number;
  inspectionResult: string;
}
function CurrentImportHistory({ inventories }: { inventories: DataType[] }) {
  const columns: ColumnsType<DataType> = [
    {
      title: 'Delivered Date',
      dataIndex: 'deliveredDate'
    },
    {
      title: 'Location',
      dataIndex: 'location',
      width: '13%'
    },
    {
      title: 'Estimated Quantity',
      dataIndex: 'estimatedQuantity'
    },
    {
      title: 'Delivered Quantity',
      dataIndex: 'deliveredQuantity'
    },
    {
      title: 'Available Quantity',
      dataIndex: 'availableQuantity'
    },
    {
      title: 'Unavailable Quantity',
      dataIndex: 'unavailableQuantity'
    },
    {
      title: 'Inspection Result',
      dataIndex: 'inspectionResult'
    }
  ];
  return (
    <Table
      className="warehouse-table"
      columns={columns}
      dataSource={inventories}
      pagination={false}
    />
  );
}

export default CurrentImportHistory;
